// extracted by mini-css-extract-plugin
export default {"header":"HeaderList_header__JvbaM","titleWrap":"HeaderList_titleWrap__m0fpx","title":"HeaderList_title__HoVng","backWrap":"HeaderList_backWrap__soV6G"};